const defaultState = {
  type: null,
}


export default function list(state = defaultState, action) {
  switch (action.type) {
    case 'GET_ITEM':
    case 'GET_ITEM_ERROR': return {
      type: null,
    }

    case 'GET_ITEM_SUCCESS': return {
      ...action.item,
      type: action.itemType || action.item.type || state.type,
    }

    default: return state
  }
}
